import { AxiosRequestConfig } from 'axios'

import { ParametersDownload } from './types'

const getRewards = ({
  startDate,
  endDate,
  storeId
}: ParametersDownload): AxiosRequestConfig => {
  const params = {
    ...(startDate ? { startDate: startDate.toISOString() } : {}),
    ...(endDate ? { endDate: endDate.toISOString() } : {}),
    ...(storeId ? { storeId } : {}),
  }

  return {
    url: 'dashboard/rewards',
    method: 'GET',
    params,
  }
}

export { getRewards }
